class MessageValueLoader implements FieldValueLoaderInterface {
	public load(value: any): void {
		return;
	}
}

export default MessageValueLoader;
